var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.725 22.8008V15.0558H18.325L18.714 12.0378H15.724V10.1108C15.724 9.23678 15.967 8.64078 17.221 8.64078H18.819V5.94078C18.0451 5.85842 17.2673 5.81836 16.489 5.82078C14.185 5.82078 12.608 7.22778 12.608 9.81078V12.0378H10V15.0558H12.607V22.8008H3.104C2.494 22.8008 2 22.3068 2 21.6968V3.90478C2 3.29478 2.494 2.80078 3.104 2.80078H20.896C21.506 2.80078 22 3.29478 22 3.90478V21.6968C22 22.3068 21.506 22.8008 20.896 22.8008H15.725Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook_icon.489b9b6a0b407e47e94e61cb21a98bd7.svg";
export { ForwardRef as ReactComponent };